import { create } from "zustand";
import { SchemeEntrie, SchemeState } from "./types";
import { $api } from "shared/api";

export const useSchemeStore = create<SchemeState>(() => ({
  entries: [],
  getEntrie: async (entryId) => {
    const path = `/stash/entry/${entryId}`;

    const entrie = await $api.get<SchemeEntrie>(path).catch(console.warn);

    if (!entrie) return null;

    const answer = {
      x: entrie?.data?.data?.x || 0,
      y: entrie?.data?.data?.y || 0
    }

    return answer
  },
  editEntrie: async (params) => {
    await $api.post('/stash/', params);
  }
}))